module.exports = __webpack_public_path__ + "img/Episodios.4920617f.svg";